import { Link, useLocation } from "react-router-dom";

import {
  Button,
  CurrencyInput,
  Drawer,
  Input,
  Loading,
  Tabs,
  Title,
} from "@components";

import styles from "../styles/change-multiple-products.module.scss";
import { useEffect, useState } from "react";
import { useDragScroll } from "shared/hooks/useDragScroll";
import { InputSearch } from "shared/components/InputSearch";
import { CatalogAPI } from "providers/CatalogAPI";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { If } from "shared/components/control-statements";

const CatalogTabs = {
  DELIVERY: {
    key: "DELIVERY",
    name: "Delivery",
  },
  INDOOR: {
    key: "INDOOR",
    name: "Indoor",
  },
};

export default function ChangeMultipleProducts() {
  const [catalogService, setCatalogService] = useState(
    CatalogTabs.DELIVERY.key,
  );
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const { scrollRef, onMouseDown } = useDragScroll();

  const pathname = useLocation().pathname;

  useEffect(() => {
    const content = document.getElementById("content");
    content.style.overflowY = "hidden";
  }, [pathname]);

  useEffect(() => {
    setLoading(true);
    const getCatalog = async () => {
      const response = await CatalogAPI.getIfoodCatalog(null, catalogService);
      const data = response.getData({});

      if (response.getErrors([]).length > 0) {
        alert({ text: response.getErrors()[0] });
        setLoading(false);
        return;
      }

      setProducts(data);
      setLoading(false);
    };

    getCatalog();
  }, [catalogService]);

  const save = async () => {
    setSaving(true);

    const response = await CatalogAPI.putIfoodCatalog(products, catalogService);

    if (response.getErrors([]).length > 0) {
      alert({ text: response.getErrors()[0] });
    } else alert({ text: "Alterações salvas com sucesso!" });

    setSaving(false);
  };

  const parseBlocksByType = (type, path) => {
    const blocks = path
      .split("/")
      .map((b) => b.trim())
      .filter(Boolean);

    switch (type) {
      case "Produto":
        return blocks.slice(0, 4);

      case "Opção":
        if (blocks.length >= 5) {
          const adjusted = [...blocks];
          adjusted.splice(3, 0, "---");
          return adjusted.slice(0, 6);
        }
        return [...blocks, "---"].slice(0, 6);

      case "Ingrediente extra":
      case "Borda":
      case "Massa":
        return blocks.slice(0, 3);

      default:
        return blocks;
    }
  };

  const updateProduct = (id, field, value) => {
    setProducts((prev) =>
      prev.map((p) => (p.id === id ? { ...p, [field]: value } : p)),
    );
  };

  const filteredProducts = products.filter((product) => {
    const blocks = parseBlocksByType(product.type, product.name);
    const searchLower = search.toLowerCase();

    return (
      (blocks[1] && blocks[1].toLowerCase().includes(searchLower)) ||
      (blocks[2] && blocks[2].toLowerCase().includes(searchLower))
    );
  });

  return (
    <div className={styles.settingsContainer}>
      <Title
        title="Preços e SKUs"
        backTo={{ url: "/configuracoes/cardapio", name: "Cardápio iFood" }}
      >
        <InputSearch
          design="two"
          placeholder="Buscar por..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="mr-15"
        />
        <Button
          design="primary"
          onClick={save}
          disabled={saving}
          loading={saving}
        >
          Salvar
        </Button>
      </Title>

      <If cond={loading}>
        <Loading fullContent />
      </If>

      <Tabs
        tabs={Object.values(CatalogTabs)}
        activeTab={catalogService}
        onTabSelected={(newCatalogTab) => setCatalogService(newCatalogTab)}
      />

      <div className={styles.changeMultipleProducts}>
        <div
          onMouseDown={onMouseDown}
          ref={scrollRef}
          className={styles.table}
          style={{
            maxHeight: "calc(100vh - 157px)",
          }}
        >
          <table>
            <thead>
              <tr>
                <th style={{ minWidth: 150 }}>TIPO</th>
                <th style={{ minWidth: 150, maxWidth: 150 }}>CATEGORIA</th>
                <th style={{ minWidth: 200, maxWidth: 200 }}>PRODUTO</th>
                <th style={{ minWidth: 150, maxWidth: 150 }}>TAMANHO</th>
                <th style={{ minWidth: 170, maxWidth: 170 }}>PERGUNTA</th>
                <th style={{ minWidth: 170, maxWidth: 170 }}>RESPOSTA</th>
                <th style={{ minWidth: 140 }}>SKU</th>
                <th style={{ minWidth: 140 }}>PREÇO</th>
              </tr>
            </thead>

            <tbody>
              {filteredProducts.map((product, index) => {
                const blocks = parseBlocksByType(product.type, product.name);

                return (
                  <tr key={`${product.id}-${index}`}>
                    <td style={{ minWidth: 150 }}>{product.type}</td>
                    <td style={{ minWidth: 150, maxWidth: 150 }}>
                      <span>{blocks[1] || "---"}</span>
                    </td>
                    <td style={{ minWidth: 200, maxWidth: 200 }}>
                      <span>{blocks[2] || "---"}</span>
                    </td>
                    <td style={{ minWidth: 150, maxWidth: 150 }}>
                      <span>{blocks[3] || "---"}</span>
                    </td>
                    <td style={{ minWidth: 170, maxWidth: 170 }}>
                      <span>{blocks[4] || "---"}</span>
                    </td>
                    <td style={{ minWidth: 170, maxWidth: 170 }}>
                      <span>{blocks[5] || "---"}</span>
                    </td>
                    <td style={{ minWidth: 140 }}>
                      <Input
                        value={product.sku}
                        design="mini"
                        onChange={(e) =>
                          updateProduct(product.id, "sku", e.target.value)
                        }
                      />
                    </td>
                    <td style={{ minWidth: 140 }}>
                      <CurrencyInput
                        design="mini"
                        value={product.price}
                        onChange={(e, m, f) =>
                          updateProduct(product.id, "price", f)
                        }
                        placeholder="R$ 0,00"
                        className="w-100"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
